import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
const testimonials = [{
  text: 'Me ayudó a entender por fin la diferencia entre arcada y atragantamiento. Solo eso ya me dio muchísima paz.',
  author: 'María G.',
  role: 'Mamá de Leo (6 meses)'
}, {
  text: 'Me gustó que no impone un solo método. Explica todo con calma y te hace sentir acompañada.',
  author: 'Laura P.',
  role: 'Mamá primeriza'
}, {
  text: 'Los bonos son súper útiles. La despensa y el plan semanal me ayudaron a pasar a la acción.',
  author: 'Carlos M.',
  role: 'Papá de Sofía (5 meses)'
}, {
  text: 'Es una guía bonita, clara y fácil de seguir. La sentí práctica de verdad.',
  author: 'Ana R.',
  role: 'Mamá de gemelos'
}, {
  text: 'Tenía mucho miedo de empezar con los sólidos. Esta guía me dio la seguridad que necesitaba para dar el primer paso.',
  author: 'Daniela S.',
  role: 'Mamá de Mateo (7 meses)'
}, {
  text: 'Las recetas son deliciosas y muy fáciles. Mi bebé las disfrutó desde el primer día.',
  author: 'Valentina L.',
  role: 'Mamá de Isabella (8 meses)'
}, {
  text: 'Por fin una guía que no te juzga por elegir papillas o BLW. Muy respetuosa y completa.',
  author: 'Camila T.',
  role: 'Mamá primeriza'
}, {
  text: 'Se la regalé a mi hermana que está embarazada. Es el mejor recurso que he encontrado sobre alimentación complementaria.',
  author: 'Roberto F.',
  role: 'Tío y pediatra'
}, {
  text: 'El plan semanal fue un salvavidas. Me quitó la presión de pensar qué darle cada día.',
  author: 'Patricia M.',
  role: 'Mamá de Emilia (6 meses)'
}, {
  text: 'Me encantó la sección de alérgenos. Muy clara y me dio mucha tranquilidad para introducirlos.',
  author: 'Andrés K.',
  role: 'Papá de Lucas (9 meses)'
}];
function TestimonialCard({
  t
}: {
  t: (typeof testimonials)[0];
}) {
  return <div className="bg-white p-8 rounded-2xl shadow-sm border border-white flex flex-col h-full min-w-[300px] w-[300px] shrink-0" data-id="element-312">
      <div className="flex gap-1 mb-6" data-id="element-313">
        {[...Array(5)].map((_, j) => <Star key={j} className="w-4 h-4 fill-terracotta text-terracotta" data-id="element-314" />)}
      </div>
      <p className="text-charcoal italic mb-8 flex-grow" data-id="element-315">"{t.text}"</p>
      <div data-id="element-316">
        <p className="font-medium text-charcoal" data-id="element-317">{t.author}</p>
        <p className="text-sm text-warmGray" data-id="element-318">{t.role}</p>
      </div>
    </div>;
}
export function Testimonials() {
  const row1 = testimonials.slice(0, 5);
  const row2 = testimonials.slice(5, 10);
  return <section className="py-24 bg-sand overflow-hidden" data-id="element-319">
      <div className="max-w-7xl mx-auto px-6 lg:px-8" data-id="element-320">
        <div className="text-center mb-16" data-id="element-321">
          <motion.h2 className="text-4xl font-serif text-charcoal mb-4" initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} data-id="element-322">
            Lo que otras familias dirían al leer esta guía
          </motion.h2>
        </div>
      </div>

      {/* Row 1 - scrolls left */}
      <div className="relative mb-6" data-id="element-323">
        <div className="flex gap-6 animate-scroll-left" data-id="element-324">
          {[...row1, ...row1, ...row1].map((t, i) => <TestimonialCard key={`r1-${i}`} t={t} data-id="element-325" />)}
        </div>
      </div>

      {/* Row 2 - scrolls right */}
      <div className="relative" data-id="element-326">
        <div className="flex gap-6 animate-scroll-right" data-id="element-327">
          {[...row2, ...row2, ...row2].map((t, i) => <TestimonialCard key={`r2-${i}`} t={t} data-id="element-328" />)}
        </div>
      </div>
    </section>;
}